<template>
    <v-container v-if="!!token && !!jwt" style="margin: auto;">
        <v-card class="password-reset-card" elevation="5">
            <v-container v-if="!success">
                <v-row dense style="padding: 1em;">
                    <h2 style="margin: auto;">Change Password</h2>
                </v-row>
                <v-row class="center" dense>
                    <v-col cols="9" sm="7" md="6">
                        <v-text-field v-model="password" outlined type="password" label="New Password"></v-text-field>
                    </v-col>
                </v-row>
                <v-row class="center" dense>
                    <v-col cols="9" sm="7" md="6">
                        <v-text-field v-model="retype" outlined type="password" label="Re-Type Password"></v-text-field>
                    </v-col>
                </v-row>
                <v-row class="center" dense>
                    <v-col class="center mt-6" cols="6">
                        <site-button :colNum="12" btnType="text" text="Submit" @click-event="submit"
                            colorClasses="secondary-icon" iconColor="primary-icon"
                            iconString="fa-solid fa-circle-check"></site-button>
                    </v-col>
                </v-row>
            </v-container>
            <v-container class="center" style="margin: 1em;" v-else>
                <h3 style="margin: auto;" class="text-success">Password Changed!</h3>
            </v-container>
        </v-card>
    </v-container>
    <v-container v-else>
        Invalid Access Credentials
    </v-container>
</template>

<script>
// import PageTypeEnums from '../../../assets/Enums/PageTypeEnums'
import { MongoMixins } from '../../mixins/mongo-mixins'
import SiteButton from '../../components/common/SiteButton.vue'

export default {
    name: 'reset-password',
    mixins: [MongoMixins],
    components: {
        'site-button': SiteButton
    },
    data: () => ({
        success: false,
        password: '',
        retype: ''
    }),
    props: {
        token: {
            type: String,
        },
        jwt: {
            type: String,
        },
    },
    methods: {
        async submit() {
            await this.resetPassword(this.password, this.token, this.jwt);
            this.$router.push({ name: 'business-login' });
        }
    }
}
</script>